(function($) {

    $.fn.modal = function( options ) {

        var $elem = this;
        var settings = $.extend({
            fadeOut: 0.1,
            fadeIn: 0.3,
            padding: 20,
            template: '<div class="modal"><div class="modal-content"><a href="javascript:" class="modal-close spinner"><i class="fa fa-times"></i></a></div></div>'
        }, options);


        $elem.close = function() {
            TweenLite.to($modal, settings.fadeOut, { autoAlpha: 0, onComplete: function() {
                $modal.remove();
            } });
            $('.container').removeClass('blurred');
            $('footer').removeClass('blurred');
        };

        var $modal = $(settings.template).hide();

        var width = settings.width + (settings.padding * 2);
        var height = settings.height + (settings.padding * 2);

        if($('body').hasClass('device-mobile')) {
            width = $(window).width();
            height = $(window).height();
            $modal.find('.modal-content').css({overflow: 'auto'});
        }

        $modal.find('.modal-content').prepend($elem).width(width).height(height);

        $modal.click(function(e) {
            if(e.target == $modal.get(0)) {
                $elem.close();
            }
        });

        $modal.find('.modal-close').click(function(e) {
            e.preventDefault();
            $elem.close();
        });

        showModal();

        function showModal() {
            $('body').append($modal);
            $modal.css({visibility: 'hidden'}).show();
            TweenLite.to($modal, settings.fadeIn, { autoAlpha: 1 });
            $('.container').addClass('blurred');
            $('footer').addClass('blurred');
        }

        return $elem;
    };



    $.imagemodal = function( url, options ) {

        var settings = $.extend({
            min_margin: 100
        }, options);

        var maxWidth = $(window).width() - settings.min_margin;
        var maxHeight = $(window).height() - settings.min_margin;

        var img = new Image();
        img.onload = function() {
            var width = this.width;
            var height = this.height;

            var size = calculateAspectRatioFit(width, height, maxWidth, maxHeight);

            $('<img src="'+this.src+'" width="'+size.width+'" height="'+size.height+'" />')
                .modal({ width: size.width, height: size.height });
        };

        img.src = url;


        function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
            var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
            return { width: srcWidth*ratio, height: srcHeight*ratio };
        }
    };


    $.errormodal = function( title, message, button, options ) {

        if(!options) options = {};
        if(!button) button = 'Close';
        var height = (options.height) ? options.height : 300;
        var width = (options.width) ? options.width : 400;
        var textheight = height - 120;

        var $title = $('<h2 class="modal-header">'+title+'</h2>');
        var $message = $('<p style="min-height: '+textheight+'px;">'+message+'</p>');
        var $btn = $('<a class="btn btn-medium modal-close" style="margin: 0 auto;" href="javascript:">'+button+'</a>');
        var $content = $('<div style="text-align: center;"></div>');
        $content.append($title).append($message).append($btn);

        $content.modal({width: width, height: height});

    };


    $.buttonmodal = function( title, message, button, callback, options ) {

        if(!options) options = {};
        var height = (options.height) ? options.height : 260;
        var width = (options.width) ? options.width : 400;
        var textheight = height - 120;

        var $content = $('<div style="text-align: center;"></div>');
        var $title = $('<h2 class="modal-header">'+title+'</h2>');
        var $message = $('<p style="min-height: '+textheight+'px; margin-bottom: 20px;">'+message+'</p>');
        var $btn = $('<a class="btn btn-medium modal-question" style="margin: 0 auto;" href="javascript:">'+button+'</a>');

        $btn.click(function() {
            callback($content);
        });

        $content.append($title).append($message).append($btn);
        $content.modal({width: width, height: height});
    }

}( jQuery ));